import { render, staticRenderFns } from "./secondary.vue?vue&type=template&id=421f216d&scoped=true"
import script from "./secondary.vue?vue&type=script&lang=js"
export * from "./secondary.vue?vue&type=script&lang=js"
import style0 from "./secondary.vue?vue&type=style&index=0&id=421f216d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421f216d",
  null
  
)

export default component.exports